exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.logs-header {\n  padding: 30px;\n}\n.logs-date {\n  float: left;\n  margin: 0;\n  font-weight: bold;\n  font-size: 16px;\n}\n.logs-version {\n  float: left;\n  margin: 0 0 0 15px;\n  font-size: 16px;\n}\n.logs-table {\n  width: 100%;\n  margin: 0 15px 30px;\n}\n.logs-table th {\n  padding-bottom: 10px;\n}\n.logs-table td {\n  padding: 0;\n}\n.logs-content {\n  width: 100%;\n  min-height: 2em;\n  display: block;\n  margin: 0;\n  border-color: white;\n  background-color: white;\n  font-size: 16px;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n}\n.logs-note {\n  color: #787878;\n}\n.logs-body {\n  clear: both;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-c6b36f4a","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/modules/UpdateLogs.vue
// module id = 393
// module chunks = 1